import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { EmployeeTokenConsumptionReportModel } from './employee-token-cons-report.model';

export class EmployeeTokenConsumptionReportResponse extends GlobalResponseObject {
    data?: EmployeeTokenConsumptionReportModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: EmployeeTokenConsumptionReportModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
